<template>
  <div v-if="show" class="modal-popup" @click="handleOverlayClick">
    <div class="popup" @click.stop>
      <h4>{{ title }}</h4>
      
      <p v-if="message">{{ message }}</p>
      <slot></slot>

      <div class="buttons">
        <div
          v-for="action in actions"
          :key="action.text"
          :class="['button', `btn-${action.class || 'primary'}`]"
          @click="handleAction(action)"
        >
          {{ action.text }}
        </div>

        <!-- Default OK button if no actions provided -->
        <div
          v-if="!actions || actions.length === 0"
          class="button btn-primary"
          @click="handleClose"
        >
          OK
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomModal',

  props: {
    /**
     * Whether to show the modal
     * @type {Boolean}
     */
    show: {
      type: Boolean,
      default: false
    },

    /**
     * Modal title
     * @type {String}
     */
    title: {
      type: String,
      required: true
    },

    /**
     * Modal message content
     * @type {String}
     */
    message: {
      type: String,
      default: ''
    },

    /**
     * Modal actions/buttons
     * @type {Array}
     * @example [{ text: 'Cancel', class: 'secondary', handler: () => {} }]
     */
    actions: {
      type: Array,
      default: () => []
    },

    /**
     * Whether clicking outside should close the modal
     * @type {Boolean}
     */
    closeOnOverlay: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    handleOverlayClick() {
      if (this.closeOnOverlay) {
        this.handleClose()
      }
    },

    handleClose() {
      this.$emit('close')
    },

    /**
     * Handle action button click
     * @param {Object} action - Action configuration
     */
    handleAction(action) {
      if (action.handler && typeof action.handler === 'function') {
        action.handler()
      }

      // Emit action event for parent handling
      this.$emit('action', action)

      // Auto-close unless action specifies otherwise
      if (action.autoClose !== false) {
        this.handleClose()
      }
    }
  }
}
</script>
